import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import SingleDatePickerWrapper from '../../Common/SingleDatePickerWrapper/SingleDatePickerWrapper';
import moment from 'moment';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import './SearchForm.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SearchForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videos: [],
        }
    }

    componentDidMount() {
        this.getAdminVideos();
    }

    handleDayEventChange = (day, input) => {
		this.setState({
            selectedDay: day
        });
		this.props.handleChangeDateEvent(day, input.props.id);
	}

    getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

    render() {
        const videos = this.state.videos;
		let videoUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
        videos.forEach((video) => {
            if (video.title.includes('Search')) {
                videoUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
			}
        });
        return (
            <div className="showtix-search">
                <div className="showtix-section container">

                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                        </div>
                    </div>

                    <div className="row showtix-search__form">
                        <div className="col-12 col-lg-9">
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="keyword">
                                            {strings.searchLabel}
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                id="keyword"
                                                className="showtix-input"
                                                type="text"
                                                name="keyword"
                                                onChange={this.props.handleChange}
                                                onKeyUp={this.props.handleKeyUp}
                                                value={this.props.items.query.keyword || ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="transaction_number">
                                            {strings.transactionNumber}
                                        </label>
                                        <div className="showtix-form__input">
                                            <input
                                                id="transaction_number"
                                                className="showtix-input"
                                                type="number"
                                                name="transaction_number"
                                                onChange={this.props.handleChange}
                                                onKeyUp={this.props.handleKeyUp}
                                                value={this.props.items.query.transaction_number || ''}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="event">
                                            {strings.eventsLabel}
                                        </label>
                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                id="event"
                                                name="event"
                                                onChange={this.props.handleChangeEvent}
                                                value={this.props.items.query.event || this.props.items.query.flexpass}
                                            >
                                                <option value="0">{strings.selectEvent}</option>
                                                <optgroup label={strings.events}>
                                                    {this.props.items.events.length &&
                                                        [
                                                            (this.props.items.events.map((event, i) =>
                                                                <option
                                                                    key={i}
                                                                    value={event.id}
                                                                >{event.name}</option>
                                                            ))
                                                        ]
                                                    }
                                                </optgroup>
                                                <optgroup label={strings.flexpasses}>
                                                    {this.props.items.flexpasses.length &&
                                                        [
                                                            (this.props.items.flexpasses.map((flexpass, i) =>
                                                                <option
                                                                    key={i}
                                                                    value={flexpass.id}
                                                                >{flexpass.name}</option>
                                                            ))
                                                        ]
                                                    }
                                                </optgroup>
                                                
                                                
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                { this.props.items.searchType === 'event' &&
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="date">
                                                {strings.datesLabel}
                                            </label>
                                            <div className="showtix-form__select">
                                                <select className="showtix-input"
                                                    id="date"
                                                    name="date"
                                                    onChange={this.props.handleChange}
                                                    value={this.props.items.query.date}
                                                    disabled={!this.props.items.dates.length > 0}
                                                >
                                                    <option value="0">{strings.selectDate}</option>
                                                        {this.props.items.dates.map((date, i) => {
                                                            const dateString = moment(date.event_datetime_local.substring(0, 19)).format('LLLL');
                                                            return (
                                                                <option
                                                                    key={i}
                                                                    value={date.id}
                                                                >{dateString}</option>
                                                            )
                                                        })}
                                                        
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <h2>{strings.filterByDates}</h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="transaction_start">
                                            {strings.from}
                                        </label>
                                        <div className="showtix-form__input">
                                            <SingleDatePickerWrapper 
                                                id="transaction_start"
                                                handleDayChange={this.handleDayEventChange}
                                                selectedDays={this.props.items.transaction_start}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="transaction_end">
                                            {strings.to}
                                        </label>
                                        <div className="showtix-form__input">
                                            <SingleDatePickerWrapper 
                                                id="transaction_end"
                                                handleDayChange={this.handleDayEventChange}
                                                selectedDays={this.props.items.transaction_end}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <button
                                        className="showtix-button showtix-background__primary-1"
                                        onClick={this.props.handleSearch}
                                    >{strings.searchBtn}</button>
                                </div>
                            </div>
                        </div>
                        { strings.help &&
                            <div className="col-12 col-lg-3">
                                <div className="showtix-box">
                                    <div className="showtix-padder">
                                        <h3 className="showtix-box__title">{strings.video.title}</h3>
                                        <p><a href={videoUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
                                    </div>	
                                </div>
                                <Help help={strings.help} />
                            </div>
                        }
                    </div>

                    <hr className="color-1" />
                    
                </div>
            </div>
        )
    }
}

SearchForm.propTypes = {
    items: PropTypes.shape({
        query: PropTypes.shape({
            keyword: PropTypes.string,
            event: PropTypes.number,
            date: PropTypes.number
        }),
        events: PropTypes.array
    }),
    handleChange: PropTypes.func,
    handleChangeEvent: PropTypes.func,
    submitSearch: PropTypes.func
}

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/Search/SearchForm/SearchForm.js